import CommandsPage from './commands-page.connect'

export default CommandsPage



// WEBPACK FOOTER //
// ./src/components/views/commands-page/index.js